import React, { Component } from 'react';
import './BtnTopMenu.css';
import { ASSETS_FOLDER } from '../../../../../../constants';
import { TOP_MENU } from '../../../../../../texts';
import { LINKS } from '../../../../../../content';
import * as Features from '../../../../../../utils/Features';

class BtnTopMenu extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.onClick();
  }

  render() {
    const { id } = this.props;
    const left = id * -72;
    const mainClass = `btn-top-menu ${
      Features.features.mobile ? 'mobile' : 'desktop'
    }`;

    const content = (
      <React.Fragment>
        <div className="btn-img-wrap">
          <img
            src={`${ASSETS_FOLDER}img/ico/btns-big.png`}
            alt=""
            style={{ top: 0, left }}
          />
          <img
            className="btn-bg-hover"
            src={`${ASSETS_FOLDER}img/ico/btns-big.png`}
            alt=""
            style={{ bottom: 0, left }}
          />
        </div>
        <div className="label">{TOP_MENU.LABELS[this.props.id]}</div>
      </React.Fragment>
    );

    // type by id
    if (id < 2) {
      return (
        <a
          className={mainClass}
          href={id === 0 ? LINKS.MOVIE : LINKS.DOCUMENT}
          target="_blank"
          rel="noopener noreferrer"
          onClick={this.handleClick}
        >
          {content}
        </a>
      );
    }
    return (
      <button className={mainClass} onClick={this.handleClick}>
        {content}
      </button>
    );
  }
}

export default BtnTopMenu;



// WEBPACK FOOTER //
// ./src/components/App/Dukla/Scene/SceneUI/BtnTopMenu/BtnTopMenu.js